<template>
  <div>
    <v-col cols="12">
      <v-select
        :items="categoryList"
        item-value="id"
        item-text="name"
        placeholder="Подразделение"
        label="Подразделение"
        dense
        @click="clearChildren"
        v-model="params.categoryId"
      />
    </v-col>

    <template v-if="isEntrant">
      <v-col cols="12" sm="6">
        <v-select
          :items="courseList"
          placeholder="Курс"
          label="Курс"
          dense
          v-model="params.course"
          @click="clearPupilGroup"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-select
          :items="groupListByCourse"
          :item-text="el => (el.liter ? el.liter : '-')"
          item-value="id"
          placeholder="Группа"
          label="Группа"
          dense
          v-model="params.pupilGroup"
        />
      </v-col>
    </template>
  </div>
</template>

<script>
import {
  getPupilGroupList,
  getCategoryList
} from "@/services/category.service";
export default {
  name: "EmploymentChoose",
  props: {
    group: { type: String, required: true },
    value: { type: Object }
  },

  data: () => ({
    categoryList: [],
    courseList: [],
    groupList: [],
    params: { categoryId: null, course: null, pupilGroup: null }
  }),

  computed: {
    isEntrant() {
      return this.group.toUpperCase() === "ENTRANT";
    },

    groupListByCourse() {
      return this.groupList.filter(g => g.course === this.params.course);
    }
  },

  watch: {
    group: {
      immediate: true,
      handler(newGroup) {
        if (newGroup) {
          this.loadCategories(newGroup);
          this.params = { categoryId: null, course: null, pupilGroup: null };
          this.courseList = [];
          this.groupList = [];
        }
      }
    },

    params: {
      handler(v) {
        this.$emit("update", v);
      },
      deep: true
    },

    "params.categoryId": {
      handler(v) {
        if (v && this.isEntrant) this.loadPupilGroups(v);
        if (!v) {
          this.courseList = [];
          this.groupList = [];
        }
      }
    }
  },

  methods: {
    async loadCategories(type) {
      this.categoryList = await getCategoryList(type);
    },

    async loadPupilGroups(categoryId) {
      this.groupList = await getPupilGroupList({ categoryId });
      this.courseList = [...new Set(this.groupList.map(g => g.course))].sort(
        (a, b) => a - b
      );
    },

    clearChildren() {
      this.params.course = null;
      this.params.pupilGroup = null;
    },

    clearPupilGroup() {
      this.params.pupilGroup = null;
    }
  }
};
</script>
